import React from "react";
import { Container, Col, Row, Card, ListGroup } from "react-bootstrap";

function AccountDetails({ property_details }) {
  return (
    <div>
      <Container style={{ paddingBottom: "10px" }}>
        <Card className="border border-primary">
          <Card.Body>
            <Row>
              <Col>
                {/* <Card.Title className="mb-3 mt-3">Property Details</Card.Title>{" "}
                Added margin */}
                <Card.Header
                  style={{ fontWeight: "bold" }}
                  className="bg-primary text-white"
                >
                  Property Details :
                </Card.Header>
              </Col>
            </Row>

            <Row>
              <Col>
                <ListGroup>
                  <ListGroup.Item
                    style={{ padding: "0.2rem 0.5rem" }}
                    className="border-0"
                  >
                    <strong>Collateral :</strong>
                  </ListGroup.Item>
                  <ListGroup.Item
                    style={{ padding: "0.2rem 0.5rem" }}
                    className="border-0"
                  >
                    {property_details?.[0]?.no_of_collateral}
                  </ListGroup.Item>
                  <ListGroup.Item
                    style={{ padding: "0.2rem 0.5rem" }}
                    className="border-0"
                  >
                    <strong>Escrow Account :</strong>
                  </ListGroup.Item>
                  <ListGroup.Item
                    style={{ padding: "0.2rem 0.5rem" }}
                    className="border-0"
                  >
                    {property_details?.[0]?.escrow_account}
                  </ListGroup.Item>
                  <ListGroup.Item
                    style={{ padding: "0.2rem 0.5rem" }}
                    className="border-0"
                  >
                    <strong>Address :</strong>
                  </ListGroup.Item>
                  <ListGroup.Item
                    style={{ padding: "0.2rem 0.5rem" }}
                    className="border-0"
                  >
                    {property_details?.[0]?.primary_address}
                  </ListGroup.Item>
                </ListGroup>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
}

export default AccountDetails;
